"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomStyles = exports.InputStyles = exports.StyledOverflow = exports.StyledSelectBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledSelectBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSelectBox",
  componentId: "sc-1o683mn-0"
})(["width:100%;max-width:300px;margin:0 auto;", " ", ""], function (props) {
  return !props.relative && (0, _styledComponents.css)(["position:absolute;bottom:10px;left:calc(50% - 150px);"]);
}, function (props) {
  return props.align === "vertical" && (0, _styledComponents.css)(["bottom:0;left:-10px;max-width:60px;height:100%;display:flex;align-items:center;justify-content:center;"]);
});

exports.StyledSelectBox = StyledSelectBox;

var StyledOverflow = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledOverflow",
  componentId: "sc-1o683mn-1"
})(["position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,0.1);z-index:10;"]);

exports.StyledOverflow = StyledOverflow;
var InputStyles = {
  control: function control() {
    return {
      display: "flex",
      border: "1px solid rgba(202,204,208,0.85)",
      background: "#FFF",
      borderRadius: "4px",
      padding: "3px 0"
    };
  }
};
exports.InputStyles = InputStyles;
var CustomStyles = {
  container: function container() {
    return {
      position: "relative",
      boxSizing: "border-box",
      cursor: "pointer"
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: "none"
    };
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    var _state$selectProps = state.selectProps,
        menuIsOpen = _state$selectProps.menuIsOpen,
        align = _state$selectProps.align;
    return {
      color: "#c32d7b",
      transform: menuIsOpen && align === "horizontal" ? "rotate(180deg)" : "none",
      transition: "all 0.2s ease-out"
    };
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      color: "#c32d7b",
      display: "flex",
      padding: "8px",
      transition: "color 150ms",
      boxSizing: "border-box",
      position: "relative",
      top: "5px"
    };
  },
  control: function control(provided, state) {
    var align = state.selectProps.align;
    var wordPixel = 10;
    var additionalProps = align === "vertical" ? {
      transform: "rotate(-90deg)"
    } : null;
    return _objectSpread({
      margin: "0 auto",
      display: "flex",
      border: "none",
      minWidth: "90px",
      borderRadius: "4px",
      maxWidth: "210px",
      padding: "3px 0"
    }, additionalProps);
  },
  menu: function menu(provided, state) {
    var align = state.selectProps.align;
    var additionalProps = align === "vertical" ? {
      position: "absolute",
      left: "100px",
      top: "-50px",
      bottom: "auto",
      width: "300px"
    } : null;
    return _objectSpread({}, provided, {}, additionalProps);
  }
};
exports.CustomStyles = CustomStyles;